/**
 * THP video interview A/B workflow variants (BIZ-40408).
 *
 * Mirrors the backend com.aquent.talent.domain.VideoInterviewWorkflow enum. The numeric values are
 * the stored feature_config ('thp-video-interview.workflow') codes and are returned on PostingInfo.
 */
export enum VideoInterviewWorkflow {
  WorkflowA = 1,
  WorkflowB = 2,
  SplitByTalentId = 3
}
